import {EventStatus} from '@wix/wix-events-commons-statics/dist/types/enums/events'

export const ROOT_COMPONENT_ID = 'events-members-root'

export const EXPERIMENTS_SCOPE = 'wix-events-ui'
export const MEMORY_CACHE_KEY = 'events-members-page-store'

export const UPCOMING_EVENT_STATUSES = [EventStatus.SCHEDULED, EventStatus.STARTED]
export const PAST_EVENT_STATUSES = [EventStatus.ENDED, EventStatus.CANCELED]
